import { Delete, DeleteOutline, Edit, Info } from "@mui/icons-material"
import { IconButton, Stack, Tooltip, Typography } from "@mui/material"
import CustomDataGrid from "components/customDataGrid"
import NullCheck from "components/NullCheck"
import { DATE_TIME_FORMAT, METER_TYPE, TIME_FORMAT } from "config/const"
import { createDateWithTime, findKeyByValue, findMeterQtyi18Key } from "config/functions"
import { DEPARTMENT_MANAGER, MANAGER, ROLES_ID } from "config/roles"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation"
import moment from "moment"
import { useSelector } from "react-redux"

const TableData = ({ data, setMeterDetails, deleteItem }) => {
  const { bt } = useBizTypeTranslation();
  const userRole = useSelector((state) => state.userSettings?.user?.userRole);

  return (
    <CustomDataGrid
      initialState={{ pagination: { paginationModel: { pageSize: 100, } } }}
      pageSizeOptions={[5]}
      disableRowSelectionOnClick
      rowReordering
      disableColumnMenu
      columns={[
        {
          field: "type",
          headerName: bt("TYPE"),
          width: 100,
          filterable: false,
          renderCell: (value) => bt(findKeyByValue(METER_TYPE, value?.row?.type))
        },
        {
          field: "name",
          headerName: bt("METER_NAME"),
          width: 150,
          filterable: false,
        },
        {
          field: "guid",
          headerName: bt("METER_GUID"),
          width: 150,
          filterable: false,
        },
        {
          field: "employeeName",
          headerName: bt("EMPLOYEE"),
          width: 100,
          filterable: false,
        },
        {
          field: "readValue",
          headerName: bt("READ_VALUE"),
          width: 200,
          filterable: false,
          renderCell: (value) => {
            const isExceed = value?.row?.isExceed
            return (
              <Stack direction='row' height='100%' alignItems='center' spacing={0.5}>

                <NullCheck valueForCheck={isExceed}>
                  <Tooltip title={bt("READ_IS_EXCEED")}>
                    <Info fontSize="small" sx={{ color: "error.text" }} />
                  </Tooltip>
                </NullCheck>

                <Typography color={isExceed ? 'error.text' : ''}>
                  {`${value?.row?.readValue} ${bt(findMeterQtyi18Key(value?.row?.meter?.type))}`}
                </Typography>
              </Stack>
            )
          }
        },
        {
          field: "consumption",
          headerName: bt("CONSUMPTION"),
          width: 200,
          filterable: false,
          renderCell: (value) => {
            const isExceed = value?.row?.isExceed
            return (
              <Stack direction='row' height='100%' alignItems='center' spacing={0.5}>

                <NullCheck valueForCheck={isExceed}>
                  <Tooltip title={bt("READ_IS_EXCEED")}>
                    <Info fontSize="small" sx={{ color: "error.text" }} />
                  </Tooltip>
                </NullCheck>

                <Typography color={isExceed ? 'error.text' : ''}>
                  {`${value?.row?.consumption} ${bt(findMeterQtyi18Key(value?.row?.meter?.type))}`}
                </Typography>
              </Stack>
            )
          }
        },
        {
          field: "created",
          headerName: bt("CREATED_READ"),
          width: 200,
          filterable: false,
          renderCell: (value) => {
            const isBetweenRange = value?.row?.isBetweenRange
            return (
              <Stack direction='row' height='100%' alignItems='center' spacing={0.5}>

                <NullCheck valueForCheck={!isBetweenRange}>
                  <Tooltip title={bt("IS_NOT_BETWEEN_RANGE")}>
                    <Info fontSize="small" color="warning" />
                  </Tooltip>
                </NullCheck>

                <Typography color={isBetweenRange ? '' : 'warning.main'}>
                  {`${moment(value?.row?.created).format(DATE_TIME_FORMAT)}`}
                </Typography>
              </Stack>
            )
          }
        },
        {
          field: "edit",
          headerName: bt("EDIT"),
          width: 100,
          hide: !DEPARTMENT_MANAGER?.includes(userRole),
          hideInExport: true,
          filterable: false,
          renderCell: (value) => {
            return (
              <IconButton
                onClick={(e) => {
                  setMeterDetails(value?.row);
                }}
              >
                <Edit />
              </IconButton>
            );
          },
        },
        {
          field: "delete",
          headerName: bt("DELETE"),
          width: 100,
          hide: !MANAGER?.includes(userRole),
          filterable: false,
          hideInExport: true,
          renderCell: (values) => {
            return (
              <NullCheck
                valueForCheck={
                  values?.row?.userRole !== ROLES_ID.SU_ADMIN &&
                  values?.row?.userRole !== ROLES_ID.MANAGER
                }
              >
                <IconButton
                  onClick={(e) => {
                    deleteItem(values.id);
                  }}
                >
                  <DeleteOutline sx={{ color: "error.text" }} />
                </IconButton>
              </NullCheck>
            );
          },
        },
      ]}
      list={data?.map((item) => {
        const startRecommend = item?.meter?.startRecommendTimeRead
          ? moment(createDateWithTime(null, item?.meter?.startRecommendTimeRead))
          : null
        const endRecommend = item?.meter?.endRecommendTimeRead
          ? moment(createDateWithTime(null, item?.meter?.endRecommendTimeRead))
          : null
        let createdTime = moment(item?.created).format(TIME_FORMAT)
        createdTime = moment(createDateWithTime(null, createdTime))

        return {
          ...item,
          id: item?._id,
          type: item?.meter?.type,
          name: item?.meter?.name,
          guid: item?.meter?.guid,
          isHappy: item?.isHappy,
          created: item?.created,
          employeeName: item?.employeeName,
          readValue: parseFloat(item?.readValue).toFixed(2),
          consumption: parseFloat(item?.consumption).toFixed(2),
          isExceed: item?.isExceed,
          isBetweenRange: startRecommend
            ? moment(createdTime).isBetween(startRecommend, endRecommend)
            : true,
        };
      })}
    />
  )
}
export default TableData
